import React, { Fragment, useState } from 'react'
import SvgHide from 'src/components/Svgs/SvgHide'
import SvgHideHover from 'src/components/Svgs/SvgHideHover'
import SvgShow from 'src/components/Svgs/SvgShow'
import SvgShowHover from 'src/components/Svgs/SvgShowHover'
import { css } from 'styled-components'

interface EyeCheckboxProps {
  className?: string
  isSelected: boolean
  onClick: () => void
  disabled?: boolean
}

const EyeCheckbox: React.FC<EyeCheckboxProps> = (props): React.ReactElement => {
  const [hover, setHover] = useState(false)
  return (
    <div
      onMouseEnter={(): void => setHover(true)}
      onMouseLeave={(): void => setHover(false)}
      className={props.className}
      css={css`
        height: 20px;
        width: 20px;
        cursor: pointer;

        ${!!props.disabled &&
        css`
          pointer-events: none;
        `};
      `}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      aria-label="Show or Hide Field"
      tabIndex={0}
    >
      {props.isSelected && (
        <Fragment>
          {hover ? (
            <SvgHideHover
              css={css`
                transform-origin: top;
                transform: scale(calc(20 / 24));
              `}
            />
          ) : (
            <SvgHide
              css={css`
                transform-origin: top;
                transform: scale(calc(20 / 24));
              `}
            />
          )}
        </Fragment>
      )}
      {!props.isSelected && (
        <Fragment>
          {hover ? (
            <SvgShowHover
              css={css`
                transform-origin: top;
                transform: scale(calc(20 / 24));
              `}
            />
          ) : (
            <SvgShow
              css={css`
                transform-origin: top;
                transform: scale(calc(20 / 24));
              `}
            />
          )}
        </Fragment>
      )}
    </div>
  )
}

export default EyeCheckbox
